import React from "react";
import CovidCenters from './components/CovidCenters'

function App() {
  return (
    <div className="row">
      <div className="col-md-10 offset-md-1">
        <CovidCenters ></CovidCenters>
      </div>
    </div>
  );
}

export default App;
